import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import CourseMapDetails from "./routes/CourseMapDetails";

export default store => ({
  path: "course-map",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "course-map" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [CourseMapDetails(store)],
});
